import React from 'react'
import { Timeline, Typography } from 'antd'

import { EVENT_TYPES } from '../../common/constants'
import { formatCreatedByText } from '../../common/utils'

const renderIngredientCommonNegativeSynonymEvent = event => {
  const { type, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created {changes.type} {changes.phrase}
        </Typography.Text>
        <br />
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  return (
    <Timeline.Item key={event.id}>
      <Typography.Text>
        Deleted {original.type} {original.phrase}
      </Typography.Text>
      <br />
      <Typography.Text>
        {formatCreatedByText(createdAt, createdBy.name)}
      </Typography.Text>
    </Timeline.Item>
  )
}

export default renderIngredientCommonNegativeSynonymEvent
